import { RootState } from "@/store/types";
import axios, { AxiosResponse } from "axios";
import { ActionTree } from "vuex";
import {
  EmailDetailEventsFilterParams, EmailDetailEventsInfo,
  EmailDetailFilterParams,
  EmailDetailItemInfo,
  EmailGroupEventsFilterParams, EmailGroupEventsItem,
  EmailGroupFilterParams,
  EmailGroupItem,
  StatisticState
} from "./types";


export const actions: ActionTree<StatisticState, RootState> = {

  async getEmailStatisticDetail({commit}, params: EmailDetailFilterParams) {
    commit("setLoading", true);
    try {
      const resp = await axios({
        url: "/stats-api/detail/email",
        params: params,
      });
      let messages = resp.data?.messages ?? [];
      if (params.page_number > 1) {
        commit("pushEmailStatisticDetail", messages);
      } else {
        commit("setEmailStatisticDetail", messages);
      }
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async getEmailStatisticDetailInfo({commit}, id: string) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<EmailDetailItemInfo> = await axios({
        url: "/stats-api/detail/email/".concat(encodeURIComponent(id)),
      });
      return resp.data;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async exportEmailStatisticDetail({commit}, filterParams: EmailDetailFilterParams) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<{status: string}> = await axios({
        url: "/stats-api/detail/email/export",
        params: filterParams,
      });
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async getEmailMessage({commit}, id: string): Promise<string> {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<{message: string}> = await axios({
        url: `/stats-api/detail/email/${encodeURIComponent(id)}/message`,
      })
      return resp.data.message;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async checkEmailMessage({commit}, data: any) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<{status: string}> = await axios({
        method: 'post',
        url: `/acapi/tools/email/check`,
        data: data
      })
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async resendEmailMessage({commit}, data: any) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<{status: string}> = await axios({
        method: 'post',
        url: `/acapi/tools/email/resend`,
        data: data
      })
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },

  async getEmailStatisticGroup({commit}, filterParams: EmailGroupFilterParams) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<{messages_count: number, messages: EmailGroupItem[]}> = await axios({
        url: "/stats-api/group/email",
        params: filterParams,
      });
      commit("setEmailStatisticGroup", resp.data.messages);
      commit('setMessagesCount', resp.data.messages_count);
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async exportEmailStatisticGroup({commit}, filterParams: EmailGroupFilterParams) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<{status: string}> = await axios({
        url: "/stats-api/group/email/export",
        params: filterParams,
      });
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },

  async getEmailStatisticGroupEvents({commit}, filterParams: EmailGroupEventsFilterParams) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<{events: EmailGroupEventsItem[]}> = await axios({
        url: "/stats-api/group/email/events",
        params: filterParams,
      });
      commit("setEmailStatisticGroupEvents", resp.data);
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async exportEmailStatisticGroupEvents({commit}, filterParams: EmailGroupEventsFilterParams) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<{status: string}> = await axios({
        url: "/stats-api/group/email/events/export",
        params: filterParams,
      });
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async getEmailDetailEvents({commit}, params: {id: string, filter: EmailDetailEventsFilterParams}) {
    commit("setLoading", true);
    try {
      const resp: any = await axios({
        url: `/stats-api/detail/email/${encodeURIComponent(params.id)}/events`,
        params: params.filter,
      });
      commit("setEmailDetailEvents", resp.data.events);
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async exportEmailDetailEvents({commit}, params: {id: number, filter: EmailDetailEventsFilterParams}) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<{status: string}> = await axios({
        url: `/stats-api/detail/email/${encodeURIComponent(params.id)}/events/export`,
        params: params.filter,
      });
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async getEmailDetailEventsInfo({commit}, {message_id, id}) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<EmailDetailEventsInfo[]> = await axios({
        url: `/stats-api/detail/email/${message_id.replace(/#/g, "%23")}/events/${id.replace(/#/g, "%23")}`,
      });
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
};
